/**
 *
 * File: PlansRequest.js
 *
 */
(function () {
    angular
        .module('maApp.remoteRequests')
        .factory('PlansRequest', PlansRequest);
    PlansRequest.$inject = ['$http', '$interpolate', 'endpoint', 'Auth', 'RequestError'];
    function PlansRequest($http, $interpolate, endpoint, Auth, RequestError) {

        return {
            'get': readEvents,
            'post': createEvents,
            'put': updateEvents,
            'delete': deleteEvents,
            'exists': doesYearAndPrescriptionCombinationExists
        };

        function readEvents(id, projectId, isplanned, additionalParameters) {
            var idPath = '';
            var projectParam = '';
            if (typeof isplanned == 'undefined') {
                isplanned = 0
            }
            if (id) {
                idPath = id + "/";
            }
            if (projectId) {
                projectParam = 'project=' + projectId + '&';
            }
            if (additionalParameters) {
                additionalParameters += '&';
            } else {
                additionalParameters = ''
            }

            var templateUrl = "{{endpoint}}managementevents/{{idPath}}?dataonly=1&isactive=1&isplanned={{isplanned}}&{{projectParam}}{{additionalParameters}}{{auth}}";
            var templateOptions = {
                'endpoint': endpoint,
                'auth': Auth.getUserAuthQueryStr(),
                'idPath': idPath,
                'projectParam': projectParam,
                'isplanned': isplanned,
                'additionalParameters': additionalParameters
            };
            return $http.get($interpolate(templateUrl)(templateOptions))
                .then(readSuccess, readFail);

            function readSuccess(response){
                return response.data;
            }

            function readFail(response){
                throw new RequestError(response, 'Failed to fetch plans');
            }
        }

        function createEvents(data) {
            if (!data) {
                throw new Error('Events.post called with a falsey  "data" argument');
            }
            if(!data.isactual && !data.isplanned){
                data.isplanned = 1;  //default to planned event if not provided
            }
            var templateUrl = "{{endpoint}}managementevents/?dataonly=1&{{auth}}";
            var templateOptions = {'endpoint': endpoint, 'auth': Auth.getUserAuthQueryStr()};
            return $http({
                method: 'POST',
                url: $interpolate(templateUrl)(templateOptions),
                data: decodeURIComponent(jQuery.param(data)),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .then(createSuccess, createFail);

            function createSuccess(response){
                return response.data;
            }

            function createFail(response){
                throw new RequestError(response, 'Failed to create plan');
            }
        }

        function updateEvents(data) {
            if (!data) {
                throw new Error('Events.put called with a falsey  "data" argument');
            }
            if (!data.id) {
                throw new Error('Events.put called with a falsey  "data.id" argument');
            }
            var templateUrl = "{{endpoint}}managementevents/{{id}}/?dataonly=1&{{auth}}";
            var templateOptions = {'endpoint': endpoint, 'auth': Auth.getUserAuthQueryStr(), 'id': data.id};
            return $http({
                method: 'PUT',
                url: $interpolate(templateUrl)(templateOptions),
                data: decodeURIComponent(jQuery.param(data)),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .then(updateSuccess, updateFail);

            function updateSuccess(response){
                return response.data;
            }

            function updateFail(response){
                throw new RequestError(response, 'Failed to update plan');
            }
        }

        function deleteEvents(data) {
            if (!data) {
                throw new Error('Events.put called with a falsey  "data" argument');
            }
            if (!data.id) {
                throw new Error('Events.put called with a falsey  "data.id" argument');
            }
            var templateUrl = "{{endpoint}}managementevents/{{id}}/?dataonly=1&{{auth}}";
            var templateOptions = {'endpoint': endpoint, 'auth': Auth.getUserAuthQueryStr(), 'id': data.id};
            return $http({
                method: 'DELETE',
                url: $interpolate(templateUrl)(templateOptions),
                data: decodeURIComponent(jQuery.param(data)),
                headers: {'Content-Type': 'application/x-www-form-urlencoded'}
            })
                .then(deleteSuccess, deleteFail);

            function deleteSuccess(response){
                return response.data;
            }

            function deleteFail(response){
                throw new RequestError(response, 'Failed to delete plan');
            }
        }

        function doesYearAndPrescriptionCombinationExists(project, year, prescriptionid) {
            var templateParams = 'year={{year}}&composite={{prescriptionid}}';
            var templateOptions = {'year': year, 'prescriptionid': prescriptionid};
            return readEvents(null, project, 1, $interpolate(templateParams)(templateOptions));
        }

    }
})();